/** @format */

// Keep in sync with constants.py
export const MEGABYTE = 1024 ** 2
export const GIGABYTE = 1024 ** 3
